import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollProgress from '../components/ScrollProgress';
import { mockData } from '../data/mock';

const PrivacyPage = () => {
  return (
    <>
      <ScrollProgress />
      <Header />
      <main className="pt-24 pb-16">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-neutral-900 mb-8">Datenschutzerklärung</h1>

            <div className="prose prose-lg max-w-none">
              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                1. Datenschutz auf einen Blick
              </h2>

              <h3 className="text-lg font-semibold text-neutral-900 mt-6 mb-3">
                Allgemeine Hinweise
              </h3>
              <p className="text-neutral-600 mb-4">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>

              <h3 className="text-lg font-semibold text-neutral-900 mt-6 mb-3">
                Datenerfassung auf dieser Website
              </h3>
              <p className="text-neutral-600 mb-4">
                <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen
                Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                2. Hosting
              </h2>
              <p className="text-neutral-600 mb-4">
                Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
              </p>

              <h3 className="text-lg font-semibold text-neutral-900 mt-6 mb-3">
                Externes Hosting
              </h3>
              <p className="text-neutral-600 mb-4">
                Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website
                erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v.a.
                um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten,
                Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert
                werden, handeln.
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                3. Allgemeine Hinweise und Pflichtinformationen
              </h2>

              <h3 className="text-lg font-semibold text-neutral-900 mt-6 mb-3">
                Datenschutz
              </h3>
              <p className="text-neutral-600 mb-4">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir
                behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>

              <h3 className="text-lg font-semibold text-neutral-900 mt-6 mb-3">
                Hinweis zur verantwortlichen Stelle
              </h3>
              <p className="text-neutral-600 mb-4">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
                Erste-Hilfe Fokus<br />
                {mockData.company.address.street}<br />
                {mockData.company.address.zip} {mockData.company.address.city}<br /><br />
                Telefon: 0159 0226 8861<br />
                E-Mail: {mockData.company.email}
              </p>

              <h3 className="text-lg font-semibold text-neutral-900 mt-6 mb-3">
                Speicherdauer
              </h3>
              <p className="text-neutral-600 mb-4">
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt
                wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die
                Datenverarbeitung entfällt.
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                4. Datenerfassung auf dieser Website
              </h2>

              <h3 className="text-lg font-semibold text-neutral-900 mt-6 mb-3">
                Cookies
              </h3>
              <p className="text-neutral-600 mb-4">
                Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Datenpakete
                und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für
                die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem
                Endgerät gespeichert.
              </p>

              <h3 className="text-lg font-semibold text-neutral-900 mt-6 mb-3">
                Kontaktformular
              </h3>
              <p className="text-neutral-600 mb-4">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem
                Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung
                der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                5. Analyse-Tools und Werbung
              </h2>
              <p className="text-neutral-600 mb-4">
                Diese Website verwendet derzeit keine Analyse-Tools oder Werbedienste von Drittanbietern.
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                6. Plugins und Tools
              </h2>

              <h3 className="text-lg font-semibold text-neutral-900 mt-6 mb-3">
                Google Maps
              </h3>
              <p className="text-neutral-600 mb-4">
                Diese Seite nutzt den Kartendienst Google Maps. Anbieter ist die Google Ireland Limited
                („Google“), Gordon House, Barrow Street, Dublin 4, Irland. Mit Hilfe dieses Dienstes
                können wir Kartenmaterial auf unserer Website einbinden.
              </p>

              <h3 className="text-lg font-semibold text-neutral-900 mt-6 mb-3">
                Google Fonts (lokales Hosting)
              </h3>
              <p className="text-neutral-600 mb-4">
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google Fonts.
                Die Google Fonts sind lokal installiert. Eine Verbindung zu Servern von Google findet
                dabei nicht statt.
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                7. Ihre Rechte
              </h2>
              <p className="text-neutral-600 mb-4">
                Sie haben das Recht:<br />
                • Auskunft über Ihre bei uns gespeicherten Daten zu erhalten<br />
                • Berichtigung unrichtiger Daten zu verlangen<br />
                • Löschung Ihrer Daten zu verlangen<br />
                • Einschränkung der Verarbeitung zu verlangen<br />
                • Widerspruch gegen die Verarbeitung einzulegen<br />
                • Datenübertragbarkeit zu verlangen
              </p>

              <p className="text-neutral-600 mt-8">
                <em>Stand: August 2025</em>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPage;
